import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';

// const ENTITIES_KEY = '@gsm/entities';
// const ELEMENTS_KEY = '@gsm/ui-lib-elements';

let packageJson: any;
try {
  packageJson = require('../../../../../../package.json');
} catch (e) {
  packageJson = {dependencies: {}};
}

@Injectable({
  providedIn: 'root'
})
export class GsmVersionCompatibilityGuard implements CanActivate {
  //private readonly gsmService = inject(GsmService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(true);
    // TODO - gsm elements ist nicht mehr als dependency eingebunden
    // braucht es diese Überprüfung trotzdem noch?
    /*return this.gsmService.assertGsmPackageVersions(
        packageJson.dependencies[ENTITIES_KEY],
        packageJson.dependencies[ELEMENTS_KEY],
      ).pipe(
        map((value: VersionInfoModel | null) => !!value),
      );*/
  }

}
